import {
  MultiSelectFilter,
  type MultiSelectFilterOption,
} from '@/components/matrix-grid/multi-select-filter';

export type NotesMultiFilterOption<T extends string> = MultiSelectFilterOption<T>;

export interface NotesMultiFilterProps<T extends string> {
  /** « Niveau », « Auteur », « Cible ». */
  label: string;
  options: readonly NotesMultiFilterOption<T>[];
  selected: readonly T[];
  onChange: (selected: T[]) => void;
}

/**
 * A multi-choice filter of the Notes view (planche 12): the same filter as the
 * matrix grid's, a button with the count of checked values and a panel of
 * checkboxes.
 */
export function NotesMultiFilter<T extends string>(props: NotesMultiFilterProps<T>) {
  return <MultiSelectFilter {...props} />;
}
